import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LETTERS = ["Z", "E", "N", "I", "Q", "U", "E"];

export default function Preloader() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const timer = setTimeout(() => {
      setDone(true);
      document.body.style.overflow = "";
    }, 2400);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] bg-noir flex flex-col items-center justify-center"
          data-testid="preloader"
        >
          <div className="flex overflow-hidden" data-testid="preloader-monogram">
            {LETTERS.map((letter, i) => (
              <motion.span
                key={i}
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 + i * 0.07, ease: [0.22, 1, 0.36, 1] }}
                className="font-serif font-light text-4xl md:text-6xl tracking-[0.35em] text-cream"
              >
                {letter}
              </motion.span>
            ))}
          </div>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.1, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="mt-7 h-px w-40 bg-gold"
          />
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 1.4 }}
            className="mt-6 text-[10px] tracking-[0.5em] uppercase text-taupe"
            data-testid="preloader-tagline"
          >
            Lifestyle · Interior Styling
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
